<template>
  <section class="app-main">
      <!-- <router-view :key="key"></router-view> -->
      <!-- <router-view></router-view> -->
      <!-- <div>{{ $route.meta.iskeepAlive}}</div> -->
      <Keep-alive >
          <router-view v-if="$route.meta.iskeepAlive"></router-view>
      </Keep-alive>
      <transition name="fade" mode="out-in">
        <router-view v-if="!$route.meta.iskeepAlive"></router-view>
      </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  },
  created () {
    // console.log("lllssssssssss",this.$route)
  },
}
</script>
<style  lang="scss" scoped>
  .app-main{
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue